<!-- Button -->
<button mat-icon-button [matTooltip]="tooltip() ?? 'Vollbildmodus umschalten'" (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTemplate() ?? defaultIconTemplate"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTemplate>
    <mat-icon svgIcon="mat_outline:fullscreen"></mat-icon>
</ng-template>
